import { render, staticRenderFns } from "./SIRS.vue?vue&type=template&id=100bdd30&scoped=true&"
import script from "./SIRS.vue?vue&type=script&lang=js&"
export * from "./SIRS.vue?vue&type=script&lang=js&"
import style0 from "./SIRS.vue?vue&type=style&index=0&id=100bdd30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100bdd30",
  null
  
)

export default component.exports